import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SemanalCenario } from 'types/Relatorios/Semanal';

export interface SemanalDataAnalisada {
  mes: number;
  ano: number;
  dia: number;
}

export interface RelatoriosSemanalState {
  mes: number;
  ano: number;
  dia: number;
  cenario: SemanalCenario;
}

const now = new Date();
const initialState: RelatoriosSemanalState = {
  mes: now.getMonth() + 1,
  ano: now.getFullYear(),
  dia: now.getDate(),
  cenario: 'preliminar',
};

const relatoriosSemanalSlice = createSlice({
  name: 'relatoriosSemanal',
  initialState,
  reducers: {
    setDataAnalisada: (state, action: PayloadAction<SemanalDataAnalisada>) => {
      state.mes = action.payload.mes;
      state.ano = action.payload.ano;
      state.dia = action.payload.dia;
    },
    setCenario: (state, action: PayloadAction<SemanalCenario>) => {
      state.cenario = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setDataAnalisada, setCenario, reset,
} = relatoriosSemanalSlice.actions;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fatiaSemanal = (state: any): RelatoriosSemanalState => state.relatoriosSemanal;
/**
 * Memorizado: devolve o mesmo objeto enquanto a data não muda. O `useSelector` compara por
 * referência, e um objeto novo a cada chamada desenharia de novo, a cada ação do Redux (RTK Query,
 * polling), toda tela que lê a data.
 */
export const selectSemanalDataAnalisada = createSelector(
  [
    (state: unknown) => fatiaSemanal(state).mes,
    (state: unknown) => fatiaSemanal(state).ano,
    (state: unknown) => fatiaSemanal(state).dia,
  ],
  (mes, ano, dia): SemanalDataAnalisada => ({ mes, ano, dia }),
);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectSemanalCenario = (state: any): SemanalCenario => (
  state.relatoriosSemanal.cenario
);

export default relatoriosSemanalSlice.reducer;
